/* eslint-disable import/no-cycle */
import React from "react";
import { Grid, TableCell, TableRow } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm, FormProvider } from "react-hook-form";
import PTMButton from "../PTMButton";
import { PTMInput } from "../index";

export default function PTMEditTableMultiLineEntryDraggable(props) {
    const {
        isActive,
        removeHandler,
        columns,
        row,
        addToIsDirtyArray,
        removeFromIsDirtyArray,
    } = props;
    const [isEditing, setIsEditing] = React.useState(row.tmpId);
    const {
        control,
        reset,
        getValues,
        formState: {
            isDirty,
            isValid,
        },
    } = useForm({
        mode: "onChange",
        defaultValues: row,
    });

    React.useEffect(() => {
        if (isDirty) {
            if (addToIsDirtyArray) addToIsDirtyArray(getValues("id"));
        } else if (removeFromIsDirtyArray) removeFromIsDirtyArray(getValues("id"));
    }, [isDirty]);

    return (
        <TableRow>
            <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {isActive
                        ? (
                            <>
                                <PTMButton
                                    variant="contained"
                                    disabledPopover={removeHandler?.disabledPopover}
                                    popover="Entfernen"
                                    color="error"
                                    sx={{ height: "100%", marginRight: "2px", padding: "6px 9px" }}
                                >
                                    <FontAwesomeIcon icon="times" />
                                </PTMButton>
                                <PTMButton
                                    variant="contained"
                                    popover="Bearbeiten"
                                    disabled={isEditing}
                                    sx={{
                                        height: "100%", marginRight: "2px", padding: "6px 7px",
                                    }}
                                    onClick={() => setIsEditing(!isEditing)}
                                >
                                    <FontAwesomeIcon icon="pen" />
                                </PTMButton>
                                <PTMButton
                                    variant="contained"
                                    popover="Verwerfen"
                                    disabled={!isEditing}
                                    color="warning"
                                    sx={{
                                        height: "100%", marginRight: "2px", padding: "6px 7px",
                                    }}
                                    onClick={() => {
                                        reset();
                                        setIsEditing(false);
                                    }}
                                >
                                    <FontAwesomeIcon icon="redo-alt" />
                                </PTMButton>
                                <PTMButton
                                    variant="contained"
                                    popover="Speichern"
                                    disabled={!isEditing || !isDirty || !isValid}
                                    color="success"
                                    sx={{
                                        height: "100%", marginRight: "2px", padding: "6px 8px",
                                    }}
                                >
                                    <FontAwesomeIcon icon="save" />
                                </PTMButton>
                            </>
                        )
                        : (
                            <PTMButton
                                variant="contained"
                                popover="Wiederherstellen"
                                color="warning"
                                sx={{
                                    height: "100%", marginRight: "2px", padding: "6px 8px",
                                }}
                            >
                                <FontAwesomeIcon icon="redo-alt" />
                            </PTMButton>
                        )}
                </div>
            </TableCell>
            <FormProvider control={control}>
                {columns.map((column) => (
                    <TableCell key={column.id}>
                        {Array.isArray(column.dataName) ? (
                            <Grid container {...column.direction && { flexDirection: column.direction }}>
                                {column.dataName.map((data) => (
                                    <Grid item xs={data.xs} key={data.name}>
                                        {isEditing && (
                                            <PTMInput
                                                {...data}
                                                name={data.name}
                                                fullWidth
                                            />
                                        )}
                                        {!isEditing && (
                                            data.optionsFormat ? data.options.find((option) => option[data.optionsKey] === row[data.name])?.[data.optionsName] : row[data.name]
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <>
                                {isEditing && (
                                    <PTMInput
                                        name={column.dataName.name}
                                        fullWidth
                                    />
                                )}
                                {!isEditing && (
                                    column.dataName.optionsFormat ? column.dataName.optionsFormat(row) : row[column.dataName.name]
                                )}
                            </>
                        )}
                    </TableCell>
                ))}
            </FormProvider>
        </TableRow>
    );
}
